module.exports = __webpack_public_path__ + "static/img/sangdi4.4e4fc957.jpg";